const comm = {
    // SERVER_URL: "http://localhost:4000"
     SERVER_URL: "https://back.lionsclubs.co.kr"
    // SERVER_URL: "https://lionsclubs.co.kr/backend"
    // SERVER_URL: "http://3.34.102.218:4000"
}  

export default comm;
